import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { getCountryFlag } from '@/lib/countries'
import { formatInteger, formatPercent } from './formatters'
import type { TopCountriesPanel } from '@/types/analytics'

const COUNTRY_NAMES = new Intl.DisplayNames(['en'], { type: 'region' })

interface TopCountriesCardProps {
  data: TopCountriesPanel
}

export function TopCountriesCard({ data }: TopCountriesCardProps) {
  if (data.countries.length === 0) {
    return (
      <Card className="p-4">
        <CardHeader className="px-0 pb-3">
          <CardTitle className="text-base">Where they chat from</CardTitle>
          <CardDescription>Top countries</CardDescription>
        </CardHeader>
        <CardContent className="px-0 text-sm text-muted-foreground">No location data for this range.</CardContent>
      </Card>
    )
  }

  return (
    <Card className="p-4">
      <CardHeader className="px-0 pb-3">
        <CardTitle className="text-base">Where they chat from</CardTitle>
        <CardDescription>Top countries · {formatInteger(data.total)} visitors</CardDescription>
      </CardHeader>
      <CardContent className="px-0 space-y-2">
        {data.countries.map((row) => {
          const flag = getCountryFlag(row.country_code)
          return (
            <div key={row.country_code} className="flex items-center gap-3 text-xs">
              <span className="w-5 text-base leading-none" aria-hidden="true">
                {flag ?? <span className="font-mono text-muted-foreground text-xs">{row.country_code}</span>}
              </span>
              <span className="flex-1">{safeCountryName(row.country_code)}</span>
              <span className="tabular-nums text-muted-foreground">
                {formatInteger(row.visitors)} · {formatPercent(row.pct, 0)}
              </span>
            </div>
          )
        })}
      </CardContent>
    </Card>
  )
}

function safeCountryName(code: string): string {
  try {
    return COUNTRY_NAMES.of(code) ?? code
  } catch {
    return code
  }
}
